Dropzone.autoDiscover = false;

Array.prototype.slice.call(document.querySelectorAll('.droparea'))
.forEach(element => {
    var myDropzone = new Dropzone(element, {
        url: getLanguage() +"/tools/upload-file",
        maxFiles: 1,
        previewTemplate: "\n            <div class=\"dz-preview dz-file-preview\">\n                <div class=\"dz-preview-box\">\n                    <svg class=\"doc-icon\">\n                        <use href=\"/static/symbol/sprite.svg#doc\"></use>\n                    </svg>\n                    <div class=\"dz-wrapper\">\n                        <div class=\"dz-wrapper-top\">\n                            <div class=\"dz-filename\"><span data-dz-name></span></div>\n                            <div class=\"dz-size\" data-dz-size></div>\n                        </div>\n                        <div class=\"dz-wrapper-bottom\">\n                            <div class=\"dz-progress\"><span class=\"dz-upload\" data-dz-uploadprogress></span></div>\n                            <div class=\"dz-percent\">0%</div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"dz-error-message\"><span data-dz-errormessage></span></div>\n            </div>\n        ",
        success: function (response) {
            $(element).find('.file_input').val(response.xhr.response);
        }
    });

    myDropzone.on("addedfile", function(file) {
        // if (this.files[0].size < 2097152) {
            if (this.files.length > 1) {
                this.removeFile(this.files[0]);
            } else {
                this.element.querySelector('.dz-filename').title = file.upload.filename
            }
            file.previewElement.addEventListener("click", function() {
                $(element).find('.file_input').val('');
                myDropzone.removeFile(file)
            })
        // } else {
        //     myDropzone.removeAllFiles(true);
        //     alert('Размер прикрепляемого файла не должен превышать 2 Мб.');
        // }
    });

    myDropzone.on("uploadprogress", function(file) {
       this.element.querySelector('.dz-percent').innerHTML = Math.round(file.upload.progress) + '%'
    })
})
